import React from 'react'
import { Box } from '@mui/system'
import { styled } from '@mui/material/styles'
import LegalTemplate from '@/src/components/Legal/LegalTemplate'

const PREFIX = 'LegalTermsOfService'
const classes = {
  layout: `${PREFIX}-layout`,
  title: `${PREFIX}-title`
}
const LEGAL_CONTENT = `
# FDA Waiver

Last Updated: Jan 13, 2023

## Medical Evaluation Waiver
We encourage you to seek professional medical advice and evaluation prior to making your order. Any information obtained through this website or application or from communications with Orka, including any online hearing screening module and any email or telephone interactions with Orka personnel, is for informational purposes only. Orka does not provide medical advice or evaluation of any kind. As hearing aids are medical devices and may require professional advice for fitting, usage and care, it may not be in your best interest to waive medical evaluation and proceed with your order. 
 
I have been advised by Orka that the Food and Drug Administration has determined that my best health interest would be served if I had a medical evaluation by a licensed physician (preferably a physician who specializes in diseases of the ear) before purchasing a hearing aid. I do not wish a medical evaluation before purchasing a hearing aid.
 
In addition, I confirm the following:
I am at least 18 years old. 

I have had the opportunity to review the User Guide from the order placing page and know that I can enquire with a customer support representative. 

I acknowledge and understand the above, I agree to waive such a medical evaluation and proceed with my order.
`
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.layout}`]: {
    padding: '0 max(108px, calc(100% - 808px)/2)',
    [theme.breakpoints.down('md')]: {
      padding: '0 88px'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px'
    },
    paddingTop: '48px',
    paddingBottom: '138px'
  },
  [`& .${classes.title}`]: {
    padding: '40px 0',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.grey[100]
  }
}))

const LegalFDA = () => {
  return (
    <Root>
      <Box width="100%">
        <LegalTemplate legalCopy={LEGAL_CONTENT} />
      </Box>
    </Root>
  )
}

export default LegalFDA
